import { useUser } from "@/utils";

// No frontend config module exists for external URLs; the one other external
// link in the app hardcodes its host the same way (see UserDropdown).
const PRIVACY_POLICY_URL = "https://playnook.games/privacy";

/**
 * The app's `contentinfo` landmark: copyright plus the two legal links.
 *
 * Deliberately heading-free — the shell's heading sweep reads headings in DOM
 * order, and a footer heading would trail every page's real outline with noise.
 */
export function SiteFooter() {
  const { data: user } = useUser();

  // The version rides inside the link text rather than beside it, so a screen
  // reader announcing the link alone still says which document it points at.
  const termsLabel = user.tosVersion
    ? `Terms of Service (v${user.tosVersion})`
    : "Terms of Service";

  return (
    <footer className="mt-16 border-t border-border pt-8 text-sm text-muted-foreground">
      <p className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span>© {new Date().getFullYear()} PlayNook</span>
        <span aria-hidden="true">·</span>
        {/* A Django page, not a route: a plain anchor for a full-page load.
            Safe from ConfirmOnExit, which only intercepts same-origin anchors
            that carry a hash — this one has none. */}
        <a
          href="/terms/"
          className="underline hover:text-foreground focus-ring rounded-sm"
        >
          {termsLabel}
        </a>
        {/* [sp] uncomment as soon as we have the privary policy link */}
        {/* <span aria-hidden="true">·</span>
        <a
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener"
          className="underline hover:text-foreground focus-ring rounded-sm"
        >
          Privacy Policy
          <span className="sr-only"> (opens in a new tab)</span>
        </a> */}
      </p>
    </footer>
  );
}
